import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
      aria-labelledby="hero-title"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20background%20with%20soft%20coral%20and%20cream%20gradient%2C%20subtle%20manga%20style%20ink%20splashes%20and%20flowing%20lines%2C%20Japanese%20and%20Chinese%20comic%20aesthetic%2C%20dreamy%20atmosphere%2C%20clean%20and%20modern%20composition%2C%20high%20quality%20digital%20art%2C%20warm%20tones%2C%20editorial%20style&width=1600&height=900&seq=hero-bg-manga&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/50 via-foreground-950/30 to-foreground-950/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
            <div className="flex-1 text-center lg:text-left animate-fade-in-up">
              <span className="inline-flex items-center gap-2 px-4 py-1.5 text-xs font-medium text-background-50 bg-background-50/15 backdrop-blur-sm rounded-full mb-6">
                <i className="ri-sparkling-line"></i>
                最新最全的漫画官网
              </span>
              <h1
                id="hero-title"
                className="text-4xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight"
              >
                虫虫漫画
                <br />
                <span className="text-primary-400">免费阅读</span>的
                <br />
                在线漫画平台
              </h1>
              <p className="mt-6 text-base md:text-lg text-foreground-200 max-w-lg mx-auto lg:mx-0 leading-relaxed">
                海量漫画资源，每日同步更新。玄幻、热血、恋爱、武侠——
                你喜欢的漫画类型，这里全都有。
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
                <Link
                  to="/category/xuanhuan"
                  className="px-8 py-3 text-sm font-medium text-foreground-950 bg-background-50 rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  立即阅读
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
                <Link
                  to="/about"
                  className="text-sm font-medium text-background-50 hover:text-primary-300 transition-colors underline underline-offset-4 whitespace-nowrap cursor-pointer"
                >
                  了解更多
                </Link>
              </div>
            </div>

            <div className="flex-1 hidden lg:block animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              <div className="relative">
                <div className="grid grid-cols-2 gap-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Chinese%20manga%20cover%20style%2C%20epic%20fantasy%20warrior%20character%2C%20warm%20coral%20and%20gold%20tones%2C%20professional%20digital%20illustration%2C%20clean%20soft%20background&width=300&height=420&seq=hero-comic-01&orientation=portrait"
                    alt="热门漫画"
                    className="w-full rounded-lg object-cover object-top aspect-[3/4]"
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=Chinese%20romance%20manga%20cover%2C%20beautiful%20female%20character%20in%20ancient%20dress%2C%20warm%20pink%20and%20peach%20tones%2C%20professional%20digital%20illustration%2C%20clean%20soft%20background&width=300&height=420&seq=hero-comic-02&orientation=portrait"
                    alt="热门漫画"
                    className="w-full rounded-lg object-cover object-top aspect-[3/4] mt-8"
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=Chinese%20action%20manga%20cover%2C%20cool%20modern%20fighter%20character%2C%20warm%20amber%20tones%2C%20professional%20digital%20illustration%2C%20clean%20soft%20background&width=300&height=420&seq=hero-comic-03&orientation=portrait"
                    alt="热门漫画"
                    className="w-full rounded-lg object-cover object-top aspect-[3/4] -mt-4"
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=Chinese%20historical%20manga%20cover%2C%20ancient%20swordsman%20character%2C%20warm%20sepia%20tones%2C%20professional%20digital%20illustration%2C%20clean%20soft%20background&width=300&height=420&seq=hero-comic-04&orientation=portrait"
                    alt="热门漫画"
                    className="w-full rounded-lg object-cover object-top aspect-[3/4] mt-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}